<template>
  <CDropdown variant="nav-item">
    <CDropdownToggle placement="bottom-end" class="ps-1" :caret="false">
      {{ username }}
      <CAvatar :src="avatar" size="md" />
    </CDropdownToggle>
    <CDropdownMenu class="pt-0" style="max-height: 300px; overflow-y: auto;">
      <CListGroupItem v-for="network in all_networks" :key="network">
        <CDropdownItem @click="changeNetwork(network.token, network.organization.username, this)" style="cursor:pointer">
          <CFormCheck
            type="radio"
            :name="network.organization.username"
            :id="network.organization.username"
            :label="network.organization.title"
            :checked="metadata.network_id === network.organization.username"
          />
        </CDropdownItem>
      </CListGroupItem>
      <CDropdownItem @click="logOut" style="cursor:pointer">
        <CIcon icon="cil-lock-locked" /> {{ $t('header.logout') }}
      </CDropdownItem>
    </CDropdownMenu>
  </CDropdown>
</template>

<script>
import { getBaseUrl } from '@/common/utils';
import store from '@/store';
import Login from '@/views/pages/Login'
import axios from 'axios';
import { ref, onMounted } from 'vue';

export default {
  name: 'AppHeaderDropdownAccnt',
  mixins: [Login],
  setup() {
    const username = ref(store.state.user.username);
    const avatar = ref(null);
    const all_networks = ref(store.state.all_networks);
    const access_token = ref(store.state.access_token);

    const fetchAvatar = async () => {
      const avatar_url = `${getBaseUrl("gateway")}/avatar/${store.state.user.id}?size=50`;
      try {
        const response = await axios.get(avatar_url, {
          headers: {
            'Authorization': access_token.value
          },
          responseType: 'arraybuffer'
        });

        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        avatar.value = URL.createObjectURL(blob);
      } catch (error) {
        console.error('Failed to load avatar', error);
      }
    };

    onMounted(() => {
      fetchAvatar();
    });

    return {
      username,
      avatar,
      all_networks,
      fetchAvatar
    }
  },
  methods: {
    async fetchAvatar() {
      let avatar_url = `${getBaseUrl("gateway")}/avatar/${store.state.user.id}?size=50`;
      try {
        const response = await axios.get(avatar_url, {
          headers: {
            'Authorization': this.access_token
          },
          responseType: 'arraybuffer' // This helps handle image data
        });

        // Convert the response data to a blob URL
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        this.avatar = URL.createObjectURL(blob);
      } catch (error) {
        this.error = 'Failed to load avatar';
        console.error(error);
      }
    },
  },
}
</script>

